import { Container } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { Bracket, IRoundProps } from 'react-brackets';
import { BracketMatch } from '../room/types';
import './style.css';

let rounds: IRoundProps[] = [
  {
    title: 'Quarterfinals',
    seeds: [
      {
        id: 1,
        date: 'Series 0-0',
        teams: [{ name: 'TBD' }, { name: 'TBD' }],
      },
      {
        id: 2,
        date: 'Series 0-0',
        teams: [{ name: 'TBD' }, { name: 'TBD' }],
      },
      {
        id: 3,
        date: 'Series 0-0',
        teams: [{ name: 'TBD' }, { name: 'TBD' }],
      },
      {
        id: 4,
        date: 'Series 0-0',
        teams: [{ name: 'TBD' }, { name: 'TBD' }],
      },
    ],
  },
  {
    title: 'Semifinals',
    seeds: [
      {
        id: 1,
        date: 'Series 0-0',
        teams: [{ name: 'TBD' }, { name: 'TBD' }],
      },
      {
        id: 2,
        date: 'Series 0-0',
        teams: [{ name: 'TBD' }, { name: 'TBD' }],
      },
    ],
  },
  {
    title: 'Finals',
    seeds: [
      {
        id: 3,
        date: 'Series 0-0',
        teams: [{ name: 'TBD' }, { name: 'TBD' }],
      },
    ],
  },
];

type PropTypes = {
  bracketMatches?: Record<string, BracketMatch>;
};

export const TourneyBracket = ({ bracketMatches }: PropTypes) => {
  const [bracketData, setBracketData] = useState<any>(rounds);

  useEffect(() => {
    if (!bracketMatches) return;
    // mutate then clone, argh! refactor this
    for (const [key, value] of Object.entries(bracketMatches)) {
      if (!value.usernames.length) continue;
      const [round, seed] = key.split('').map((key) => +key);
      rounds[round].seeds[
        seed
      ].date = `Series ${value.results[0]}-${value.results[1]}`;
      rounds[round].seeds[seed].teams = [
        { name: value.usernames[0] },
        { name: value.usernames[1] },
      ];
    }
    setBracketData(structuredClone(rounds));
  }, [bracketMatches]);

  return (
    <Container sx={{ padding: 2 }}>
      <Bracket rounds={bracketData} bracketClassName={'tourney-bracket'} />
    </Container>
  );
};
